class ProductBlock extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback(){
        let contentElement = this.querySelector('[data-block-content]');
        this.querySelector('[data-block-title]').addEventListener('click', function(){
            this.classList.toggle('open');
            contentElement.classList.toggle('hide');
        });
    }

}
customElements.define('product-block', ProductBlock);